import { Injectable, Inject } from '@angular/core';
import { ROUTING_MENU, RouterMenuTypes } from './../../config/routing-menu';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Router } from '@angular/router';
import {
  Imposition,
  ImpositionOutput,
  Refund,
  RefundOutput,
  OtpOutput,
  ListaImposicionesCliente,
  SalesforceResponse,
  ApiError,
} from '@api/models';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { ErrorHandlerService } from '../errors/error-handler.service';
import { of } from 'rxjs';
import { ApiErrors } from '@api/constants';
import { RenewImpositionOtp } from '@api/models/response-renew-imposition';

@Injectable({
  providedIn: 'root',
})
export class DepositService {
  toPositionGlobal: boolean;

  constructor(private http: HttpClient, private errorHandlerService: ErrorHandlerService, private router: Router, @Inject(ROUTING_MENU) private routingMenu: RouterMenuTypes) {}

  getImpositions(agreement: string, subacuerdo?: string) {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.getImpositions}`;
    const params = {
      acuerdo: (+agreement).toString(),
      estadoImposicion: 'TODAS',
      codigoEntidad: '1508',
      subacuerdo: subacuerdo ?? '0',
    };

    return this.http.get<SalesforceResponse<any>>(url, { params }).pipe(
      mergeMap((result) => {
        const ListaImposicionesCliente = result?.data[0]?.EE_O_ConsultaImposicionesBE?.Respuesta?.ListaImposicionesCliente;
        const masDatos = result?.data[0]?.EE_O_ConsultaImposicionesBE?.Respuesta?.masDatos;

        if (masDatos !== "0") {
          // Validación en casos que el subacuerdo venga vacío.
        if (
          !ListaImposicionesCliente ||
          !Array.isArray(ListaImposicionesCliente) ||
          ListaImposicionesCliente.length === 0
        ) {
          return of([] as ListaImposicionesCliente[]);
        }
          const lastImposition = ListaImposicionesCliente[ListaImposicionesCliente.length - 1];
          const lastSubacuerdo = parseInt(lastImposition.subacuerdo, 10);
          return this.getImpositions(agreement, lastSubacuerdo.toString()).pipe(
            map((moreImpositions) => ListaImposicionesCliente.concat(moreImpositions))
          );
        } else {
          return of(ListaImposicionesCliente);
        }
      }),
      catchError((error: ApiError) => {
        if (error.errorCode === ApiErrors.IMP_NOT_FOUND || error.errorCode === ApiErrors.IMP_NOT_FOUND_350) {
          return of([] as ListaImposicionesCliente[]);
        } else {
          this.errorHandlerService.showError(error, () => this.router.navigate([`/${this.routingMenu.PRIVATE_AREA}/${this.routingMenu.GLOBAL_POSITION}`]));
          return of([] as ListaImposicionesCliente[])
        }
      })
    );
  }

  createImposition(imposition: Imposition) {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.createImposition}`;
    return this.http.post<ImpositionOutput>(url, imposition);
  }

  generateCreateImpositionOTP(imposition: Imposition) {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.createImpositionOTP}`;
    return this.http.post<OtpOutput>(url, imposition);
  }

  getPdfImposition(agreement: string, subagreement: string, type: string) {
    const params = { acuerdo: agreement, subacuerdo: subagreement, tipo: type };
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.getPdfImposition}`;
    return this.http
      .get<SalesforceResponse<{ strMessage: string }>>(url, { params })
      .pipe(map((response) => response.data?.[0]?.strMessage));
  }

  getMinervaImposition(id: string) {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.getMinervaImposition}/${id}`;
    return this.http.get<any>(url);
  }

  getRequiredDoc() {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.getRequiredDoc}`;
    return this.http.get<any>(url);
  }
  //TODO:tipar body de las llamadas
  generateRenewalOtp(body: any) {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.renewalOtp}`;
    return this.http.post<RenewImpositionOtp>(url, body);
  }
  generateRenewal(body: any) {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.renewal}`;
    return this.http.post<RenewImpositionOtp>(url, body);
  }
  updateSalesforceImposition(body: any) {
    const url = `${environment.apiBasePath}${environment.endpoints.deposit.updateSalesforceImposition}`
    return this.http.put(url, body)
  }
}
